import React, { useEffect, useState } from "react";
import {
  formatDateWithDayjs,
  formatToLocaleString,
  localDateString,
  showToast
} from "../../../utils/utils";
import { InvoiceDetails, commentBox } from "../../../locales/en";
import DatePicker from "../../../components/datepicker/DatePicker";
import PaymentTable from "../../../components/table/all-tables/paymenttable/PaymentTable";
import InvoicePaymentComment from "../../../components/inv-comment-update/InvoicePaymentComment";
import styles from "./../../../assets/scss/custom.module.scss";
import "./../../../assets/scss/datepicker.scss";
import "./payment.scss";
import PropTypes from "prop-types";
import {
  CURRENCY_FORMAT,
  showToastType,
  SUBMITTED
} from "../../../utils/constants/appConstants";
import UsableDatePicker from "../../../components/datepicker/UsableDatePicker";
import { useParams } from "react-router-dom";
import privateAxios from "../../../utils/axiosPrivate";
import { getChangeDateRepaidUrl } from "../../../utils/constants/apiEndPoints";

const Payments = ({ invData, fetchInvoiceData }) => {
  const { id } = useParams();
  const [differenceDate, setDifferenceDate] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [isGocardlessSubmitted, setIsGocardlessSubmitted] = useState(false);
  const getDiffOriginalDueDateAndRepayDate = (diff) => {
    setDifferenceDate(diff);
  };

  useEffect(() => {
    if (invData?.diffOriginalDueDateAndRepayDate) {
      setDifferenceDate(invData?.diffOriginalDueDateAndRepayDate);
    }
    if (invData?.dateRepaidFormatted) {
      setCurrentDate(invData?.dateRepaidFormatted);
    }
  }, [invData]);

  const handleGroupRepayDate = async (date) => {
    const formattedDate = date ? localDateString(date) : "";
    setCurrentDate(formattedDate);
    try {
      const dataToSend = {
        quoteIds: [id],
        dateRepaid: formattedDate
      };
      const response = await privateAxios.put(
        getChangeDateRepaidUrl,
        dataToSend
      );
      fetchInvoiceData();
      showToast(response?.data?.message, showToastType.success);
    } catch (error) {
      showToast(
        error?.response?.data?.message || showToastType?.errorText,
        showToastType.error
      );
    }
  };

  return (
    <div>
      <div className={styles.titleArea}>
        <h5>{InvoiceDetails?.paymentSection?.mainTitle}</h5>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom`}>
              <h5>{InvoiceDetails?.paymentSection?.subH2}</h5>
            </div>
            <p>
              {invData?.invoice?.originalDueDate &&
                formatDateWithDayjs(
                  invData?.invoice?.originalDueDate,
                  "DD-MMM-YYYY"
                )}
            </p>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle}`}>
              <h5>{InvoiceDetails?.paymentSection?.repayDate}</h5>
            </div>
            <div className="inputinvodate">
              <DatePicker
                invData={invData}
                getDiffOriginalDueDateAndRepayDate={
                  getDiffOriginalDueDateAndRepayDate
                }
                isFromPayment
                disabled={isGocardlessSubmitted}
              />
              <span className="floteText">{differenceDate}</span>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle}`}>
              <h5>
                {InvoiceDetails?.paymentSection?.clientExpectedPaymentDate}
              </h5>
            </div>
            <p />
          </div>
        </div>

        <div className="col-12 mb-3">
          <div className="blog-input-wrap">
            <PaymentTable
              invData={invData}
              onPaymentsLoaded={(payments) =>
                setIsGocardlessSubmitted(
                  payments.some((p) => p.gocardlessStatus === SUBMITTED)
                )
              }
            />
          </div>
        </div>

        <div className="col-12 mb-3">
          <div className="blog-input-wrap">
            <InvoicePaymentComment
              invData={invData}
              fetchInvoiceData={fetchInvoiceData}
              titleText={InvoiceDetails?.paymentSection?.paymentComment}
              typeCmntProp={InvoiceDetails?.paymentSection?.typeCmntProp}
              sureDeleteMsg={commentBox?.commentDeleteMsg}
              addText={commentBox?.commentAddText}
              placeholder={commentBox?.commentPlaceholderText}
              addBtnText={commentBox?.commentAddBtnText}
              responseMsg={commentBox?.commentAddText}
            />
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom`}>
              <h5>{InvoiceDetails?.paymentSection?.totalWing}</h5>
            </div>
            {invData?.totalOwingAmount && (
              <p>
                {CURRENCY_FORMAT}
                {formatToLocaleString(invData?.totalOwingAmount)}
              </p>
            )}
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom`}>
              <h5>{InvoiceDetails?.paymentSection?.dateRepaid}</h5>
            </div>
            <p>
              <UsableDatePicker
                onChange={handleGroupRepayDate}
                value={currentDate}
                placeholderText={InvoiceDetails?.paymentSection?.dateRepaid}
              />
            </p>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom`}>
              <h5>{InvoiceDetails?.paymentSection?.totalWingPaymentDate}</h5>
            </div>
            {invData?.totalOwingRepayDateAmount && (
              <p>
                {CURRENCY_FORMAT}
                {formatToLocaleString(invData?.totalOwingRepayDateAmount)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Payments.propTypes = {
  invData: PropTypes.object,
  fetchInvoiceData: PropTypes.func
};

export default Payments;
